module.exports = __webpack_public_path__ + "static/media/folder-2.494ff492.svg";